export const navLinks = [
  { href: '#feed', label: '今日快讯' },
  { href: '#packs', label: '打包合集' },
  { href: '#bigpack', label: '收藏大礼包' },
  { href: '#history', label: '往期汇总' },
  { href: '#guide', label: '方向指路' },
  { href: '#faq', label: '常见问答' },
];

export const heroQuickTags = [
  '打包合集 · 汇总帖',
  '往期热门 · 完整版',
  '一个页面 · 一网收齐',
];

export const quickUpdates = [
  {
    time: '20:42',
    date: '09-06',
    tag: '新增',
    tone: 'primary',
    title: '「周五热议」往期讨论串更新 3 条，已归入对应合集',
    brief: '切片原档缺位，内容先补到讨论线，后续打包补档见合集页。',
    mark: '热',
  },
  {
    time: '18:10',
    date: '09-06',
    tag: '更新',
    tone: 'accent',
    title: '「音乐节现场 · 话题回顾」新增 2 辑完整整理',
    brief: '按时间线顺好顺序，可直接进合集下拉，不用自己翻页拼接。',
    mark: '新',
  },
  {
    time: '15:26',
    date: '09-06',
    tag: '补档',
    tone: 'secondary',
    title: '「红毯造型盘点」往期缺档补齐，章节顺序已重排',
    brief: '几处旧档顺序错位已修正，重新比对一遍标注即可收藏。',
    mark: '修',
  },
  {
    time: '11:05',
    date: '09-06',
    tag: '热更',
    tone: 'primary',
    title: '「综艺路透 · 切片回顾」打包目录完成第二轮复核',
    brief: '本周热门线内容做了一轮去重，重复串已折叠进主帖。',
    mark: '热',
  },
  {
    time: '09:31',
    date: '09-06',
    tag: '新增',
    tone: 'accent',
    title: '「影视话题 · 讨论合集」新增一页往期速览索引',
    brief: '按片单 / 场次 / 话题三种维度拆开，进合集更快定位。',
    mark: '新',
  },
];

export const packIndex = [
  {
    name: '综艺热议 · 打包合集',
    count: 18,
    desc: '切片、讨论串与补档按季排列，一次性顺完一整条线。',
    hot: true,
  },
  {
    name: '影视话题 · 汇总帖',
    count: 24,
    desc: '按片单、场次与话题三维拆解，索引清晰不乱。',
    hot: false,
  },
  {
    name: '音乐现场 · 完整版',
    count: 12,
    desc: '以时间线串起全程回顾，章节顺序已逐条核正。',
    hot: false,
  },
  {
    name: '红毯造型 · 往期盘点',
    count: 9,
    desc: '造型方向与争议细节收录在一起，省去跨平台翻找。',
    hot: true,
  },
  {
    name: '生活话题 · 讨论合集',
    count: 15,
    desc: '轻松向吃瓜集合，热度适中，适合整段顺读收藏。',
    hot: false,
  },
  {
    name: '行业观察 · 汇总大合集',
    count: 21,
    desc: '把散落各处的行业向讨论收进同一页，方便对照。',
    hot: false,
  },
];

export const bigPacks = [
  {
    key: 'K-2609',
    name: '本月热门 · 一键收藏大礼包',
    kind: '月度合辑',
    items: 46,
    size: '约 1.2 GB',
    desc: '把本月标记为「热」的全部内容按时间线打包，一个入口全带走。',
    coverIdx: 0,
  },
  {
    key: 'K-2608',
    name: '往期精华 · 完整版大礼包',
    kind: '补档合集',
    items: 72,
    size: '约 2.4 GB',
    desc: '早期缺档已逐条补齐，章节重排完成，适合从零整段收藏。',
    coverIdx: 1,
  },
  {
    key: 'K-2607',
    name: '专题速览 · 索引型大礼包',
    kind: '速览导航',
    items: 30,
    size: '纯索引',
    desc: '只有目录与方向，想去哪一段点哪一段，下载量最轻的一包。',
    coverIdx: 2,
  },
];

export const historyList = [
  { date: '08 月底', title: '暑期讨论热度结算', note: '跨三个合集的一次集中复盘', tag: '汇总', mark: '往期' },
  { date: '08 月中', title: '音乐现场系列补档', note: '缺档补全并统一了时间轴标注', tag: '补档', mark: '完整' },
  { date: '07 月下', title: '综艺切片回顾重排', note: '把散落讨论收拢成连贯主线', tag: '整理', mark: '完整' },
  { date: '07 月上', title: '造型盘点第一辑成形', note: '新增盘目录式索引页', tag: '新增', mark: '往期' },
  { date: '06 月', title: '往期热门目录上线', note: '首次把全部合集做成可视化导航', tag: '迭代', mark: '汇总' },
];

export const guideSteps = [
  {
    step: '01',
    title: '找到要收的包',
    desc: '在上方「打包合集」与「收藏大礼包」里定位你要的方向，或从快讯流反向溯源。',
    icon: 'ri-focus-3-line',
  },
  {
    step: '02',
    title: '进合集页面',
    desc: '点进对应合集，先看目录与章节顺序，确认是否命中你要的完整版。',
    icon: 'ri-stack-line',
  },
  {
    step: '03',
    title: '收藏 / 走下载方向',
    desc: '收藏本页保留入口；如需取档，按合集内的方向指引走，一条路走到底。',
    icon: 'ri-download-cloud-2-line',
  },
];

export const faqs = [
  {
    q: '这一个页面能收齐哪些内容？',
    a: '按当前整理的归拢口径，综艺、影视、音乐、红毯、生活、行业六类方向的合集、汇总帖与补档都汇总在这里，入口统一、索引可查，不必跨平台来回翻。',
  },
  {
    q: '「打包合集」和「收藏大礼包」有什么区别？',
    a: '打包合集是按主题拆的分类索引，适合精准取用某一条线；收藏大礼包是把一批已标「热 / 完整」的内容整段打包，适合整体带走。两者各有侧重，可配合使用。',
  },
  {
    q: '大礼包里的「完整版」是什么意思？',
    a: '指的是章节顺序已重排、缺档已尽量补全的整理态，打开即按时间线顺读。若个别档位暂时无源，会在目录标注，不会用缺档冒充完整。',
  },
  {
    q: '下载 / 取档怎么做？',
    a: '本页只做方向指路，不直接提供档。进入对应合集或大礼包后，按页面内的指引到指定入口取档即可，本页不参与分发环节。',
  },
  {
    q: '收藏之后内容会变动吗？',
    a: '快讯流会持续更新，但历史合集与往期汇总的内容结构和顺序保持稳定。建议以收藏本页为准，目录变化会同步刷新到收藏。',
  },
];

export const footerCols = [
  { title: '内容分区', links: ['打包合集', '收藏大礼包', '往期汇总', '下载方向指路'] },
  { title: '本页说明', links: ['收录口径', '内容整理规范', '更新日志', '联系与反馈'] },
  { title: '其他入口', links: ['收藏本页', '快讯时间线', '分类索引', '站点地图'] },
];